import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Input from 'base/react/components/form/input'
import Button from '@everlane/button'
import LoadingAnimation from 'base/react/components/loading_animation'
import classNames from 'classnames'
import RightArrow from 'base/components/layout/right_arrow'

class EmailForm extends Component {
  static propTypes = {
    errors: PropTypes.object,
    onSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
    hideLoader: PropTypes.bool,
    buttonText: PropTypes.string,
    isFooter: PropTypes.bool,
    showLabels: PropTypes.bool,
  }

  static defaultProps = {
    buttonText: 'Continue',
    hideLoader: false,
    showLabels: false,
    label: 'Email Address',
  }

  state = {
    email: '',
  }

  // Event Handling
  onChange = event => {
    this.setState({ email: event.target.value })
  }

  // Rendering

  renderButton() {
    const loading = this.props.isLoading && !this.props.hideLoader

    if (loading) {
      return (
        <div className="login__loading-animation-container">
          <LoadingAnimation />
        </div>
      )
    } else if (this.props.isFooter) {
      return <RightArrow handleClick={this.handleSubmit} />
    } else {
      return (
        <Button
          className="flat-button--full-width"
          type="submit"
          onClick={this.handleSubmit}
          variant="rectangle"
          dark
        >
          {this.props.buttonText}
        </Button>
      )
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.onSubmit(this.state.email)
  }

  render() {
    const formClassName = classNames('login__check-email-form', {
      'form-filled': this.state.email,
    })

    const placeholder = this.props.showLabels ? 'annie@email.com' : 'Email Address'
    const name = this.props.isFooter ? 'emailaddress--footer' : 'emailaddress'
    const error = this.props.errors && this.props.errors.email

    return (
      <form className={formClassName} onSubmit={this.handleSubmit}>
        <Input
          errorPosition="bottom"
          inputClass="login__input"
          required
          error={error}
          name={name}
          type="email"
          placeholder={placeholder}
          value={this.state.email}
          onChange={this.onChange}
        />
        {this.renderButton()}
      </form>
    )
  }
}

export default EmailForm
